import $ from 'jquery';

const stetson = () => {
  $(document).ready(() => {
    /* eslint-disable */
    Array.prototype.contains = function(array) {
      return array.every(function(item) {
        return this.indexOf(item) !== -1;
      }, this);
    };
    /* eslint-enable */

    let fivevar = 'true';
    // Get footer sticked on bottom on all devices for 404.
    if ($('.error404').length) {
      if ($('header').height() === 0) {
        $('main').css(
          'height',
          window.innerHeight -
            $('footer').height() -
            30 -
            $('.header').height(),
        );
      } else {
        $('main').css(
          'height',
          window.innerHeight - $('footer').height() - $('header').height(),
        );
      }
    }
    // Autofill email. Not in use yet.
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has('email')) {
      $('#email')
        .find('input')
        .val(searchParams.get('email'));
    }

    $(window).scroll(() => {
      /* Check the location of each desired element */
      $('.timeline .hidden').each(function() {
        const bottomOfObject = $(this).offset().top + $(this).innerHeight() / 2;
        const bottomOfWindow = $(window).scrollTop() + $(window).height();
        /* If the object is completely visible in the window, fade it in */
        if (bottomOfWindow > bottomOfObject) {
          $(this).animate({ opacity: '1', top: '0' }, 500);
        }
      });
    });

    // Fallback for wiki search image blend mode
    if (window.getComputedStyle(document.body).mixBlendMode === undefined) {
      // eslint-disable-next-line prettier/prettier
      $('.wikisearch-image-container').addClass(
        'wikiseach-image-container-fallback',
      );
    }
    if (window.getComputedStyle(document.body).objectFit === undefined) {
      // eslint-disable-next-line prettier/prettier
      $('.slider-image-relative img').addClass('object-fit-fallback');
      if ($('#instagram-feed').length) {
        $('#instagram-feed img').addClass('object-fit-fallback');
      }
      // eslint-disable-next-line prettier/prettier
      $('.post-head img, .newsletter-img-container img').addClass(
        'object-fit-fallback',
      );
    }

    $('.hamburger, .hamburger-hitbox').click(function() {
      if ($(this).hasClass('hamburger-hitbox')) {
        $(this)
          .next('.hamburger')
          .toggleClass('is-active');
      } else {
        $(this).toggleClass('is-active');
      }

      $('html, body').toggleClass('overflow-hidden-mobile');

      $('#tablet-nav').slideToggle(200);
    });

    $('.slider-js').bxSlider({
      adaptiveHeight: true,
      pager: true,
      controls: false,
      auto: true,
      shrinkItems: true,
      pause: 6000,
      autoHover: true,
      speed: 500,
      slideMargin: 30,
      ticker: false,
      wrapperClass: 'slider-js',
      // touchEnabled: false,
      onSlideBefore($slideElement, oldIndex, newIndex) {
        // Animation for the sliders
        // $('.slider-image-'+newIndex).toggle('slide');
        // $('.slider-image-'+oldIndex).toggle('slide');
        $(`.slider-image-${newIndex}`).fadeIn();
        $(`.slider-image-${oldIndex}`).fadeOut();
      },
      onSliderLoad(currentIndex) {
        $('.slider-js')
          .find('.bx-viewport')
          .find('div')
          .children()
          .eq(currentIndex + 1)
          .addClass('active-slide');
        let iterator = 0;
        $('.slider-group')
          .not('.bx-clone')
          .children('input')
          .each(function() {
            // Create img tags from data-value fields
            $('.slider-image .slider-image-relative').append(
              `<img class="slider-image-${iterator}" src="${$(this).attr(
                'data-value',
              )}">`,
            );
            iterator += 1;
            $(`.slider-image-${currentIndex}`).show();
          });
      },
    });
    $('.slider-js-disabled').bxSlider({
      pager: false,
      controls: false,
      touchEnabled: false,
      wrapperClass: 'slider-js-disabled',
      onSliderLoad(currentIndex) {
        $('.slider-js')
          .find('.bx-viewport')
          .find('div')
          .children()
          .eq(currentIndex + 1)
          .addClass('active-slide');
        let iterator = 0;
        $('.slider-group')
          .not('.bx-clone')
          .children('input')
          .each(function() {
            // Create img tags from data-value fields
            $('.slider-image .slider-image-relative').append(
              `<img class="slider-image-${iterator}" src="${$(this).attr(
                'data-value',
              )}">`,
            );
            iterator += 1;
            $(`.slider-image-${currentIndex}`).show();
          });
      },
    }); // The class -disabled disabled is assigned to slider with 1 slide in the twig

    $(document).on('click', 'a[href^="#"]', function(event) {
      // Smooth scrolling to anchor
      event.preventDefault();

      $('html, body').animate(
        {
          scrollTop: $($.attr(this, 'href')).offset().top,
        },
        500,
      );
    });

    // Fix bxslider for PC. Link will be clickable
    // eslint-disable-next-line no-unused-vars
    $('.bx-viewport a').on('click', function(e) {
      const linkUrl = $(this).prop('href');
      const linkUrlattr = $(this).attr('href');
      const target = $(this).prop('target');
      if (target === '_blank') {
        // He already opens it in new tab. Do nothing
      } else if (linkUrlattr.charAt(0) === '#') {
        $('html, body').animate(
          {
            scrollTop: $($.attr(this, 'href')).offset().top,
          },
          500,
        );
      } else {
        window.location.href = linkUrl;
      }
    });

    $('.slider-group').css('opacity', '1');
    $(window).trigger('resize');

    // SLICK

    // $('.list-materials').slick({
    //   slidesToShow: 5, // If slides to show = slide count, slider wont work correctly. It will always needed to be bigger than this number
    //   infinite: true,
    //   centerMode: true,
    //   arrows: false,
    //   swipeToSlide: true,
    //   waitForAnimate: true,
    //   asNavFor: '.description-materials',
    //   responsive: [
    //     {
    //       breakpoint: 1080,
    //       settings: {
    //         arrows: false,
    //         slidesToShow: 3,
    //       },
    //     },
    //     {
    //       breakpoint: 625,
    //       settings: {
    //         arrows: false,
    //         slidesToShow: 2,
    //       },
    //     },
    //     {
    //       breakpoint: 480,
    //       settings: {
    //         arrows: false,
    //         slidesToShow: 1,
    //       },
    //     },
    //   ],
    // });
    //
    // $('.description-materials').slick({
    //   slidesToShow: 1,
    //   asNavFor: '.list-materials',
    //   centerMode: true,
    //   fade: true,
    //   arrows: false,
    //   focusOnSelect: true,
    // });
    //
    // $('.list-forms').slick({
    //   slidesToShow: 5, // If slides to show = slide count, slider wont work correctly. It will always needed to be bigger than this number
    //   infinite: true,
    //   centerMode: true,
    //   arrows: false,
    //   swipeToSlide: true,
    //   waitForAnimate: true,
    //   asNavFor: '.description-forms',
    //   responsive: [
    //     {
    //       breakpoint: 1080,
    //       settings: {
    //         arrows: false,
    //         slidesToShow: 3,
    //       },
    //     },
    //     {
    //       breakpoint: 625,
    //       settings: {
    //         arrows: false,
    //         slidesToShow: 2,
    //       },
    //     },
    //     {
    //       breakpoint: 480,
    //       settings: {
    //         arrows: false,
    //         slidesToShow: 1,
    //       },
    //     },
    //   ],
    // });
    //
    // $('.description-forms').slick({
    //   slidesToShow: 1,
    //   asNavFor: '.list-forms',
    //   centerMode: true,
    //   fade: true,
    //   arrows: false,
    //   focusOnSelect: true,
    // });

    $('.hat-color').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '.hat-colors',
      arrows: false,
      fade: true,
    });
    if ($('.hat-colors').find('.item-materials').length < 5) {
      fivevar = 'false';
      $('.hat-middle .arrow-next, .hat-middle .arrow-prev').addClass(
        'hide-for-xlarge',
      );
    }
    $('.hat-colors').slick({
      slidesToShow: 5, // If slides to show = slide count, slider wont work correctly. It will always needed to be bigger than this number
      infinite: true,
      asNavFor: '.hat-color',
      centerMode: fivevar,
      arrows: false,
      swipeToSlide: true,
      centerPadding: 0,
      waitForAnimate: true,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 1600,
          settings: {
            centerPadding: '0',
            arrows: false,
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            centerPadding: '100px',
            arrows: false,
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 480,
          settings: {
            centerPadding: '20px',
            arrows: false,
            slidesToShow: 3,
          },
        },
      ],
    });

    $('.wikitabs').on('click', 'button', function() {
      if (
        $('.wikitab-divs')
          .find(`[data-tab="${$(this).attr('data-tab')}"]`)
          .is(':hidden')
      ) {
        $('.wikitab-divs')
          .children()
          .hide();
        $('.wikitab-divs')
          .find(`[data-tab="${$(this).attr('data-tab')}"]`)
          .fadeIn();
        if ($(this).attr('data-tab') === 'materialien') {
          $('.list-materials').slick('setPosition');
          $('.description-materials').slick('setPosition');
        }
        if ($(this).attr('data-tab') === 'formen') {
          $('.list-forms').slick('setPosition');
          $('.description-forms').slick('setPosition');
        }
      }
      $('.wikitabs')
        .find('button')
        .removeClass('active');
      $(this).addClass('active');
    });

    $('.store-locator').on('click', '.select-switch', function() {
      if (
        $(this)
          .parent()
          .find('option:selected')
          .attr('value') !== undefined
      ) {
        window.open(
          $(this)
            .parent()
            .find('option:selected')
            .attr('value'),
          '_blank',
        );
        $(this)
          .parent()
          .find('select')
          .removeClass('invalid');
        window.focus();
      } else {
        $(this)
          .parent()
          .find('select')
          .addClass('invalid');
      }
    });
    $('.wikitabs').on('change focus blur', 'select', () => {
      if (
        $('.wikitab-divs')
          .find(`div[data-tab="${$('.wikitabs option:selected').data('tab')}"]`)
          .is(':hidden')
      ) {
        $('.wikitab-divs')
          .children()
          .hide();
        $('.wikitab-divs')
          .find(`div[data-tab="${$('.wikitabs option:selected').data('tab')}"]`)
          .fadeIn();
        if ($('.wikitabs option:selected').data('tab') === 'materialien') {
          $('.list-materials').slick('setPosition');
          $('.description-materials').slick('setPosition');
        }
        if ($('.wikitabs option:selected').data('tab') === 'formen') {
          $('.list-forms').slick('setPosition');
          $('.description-forms').slick('setPosition');
        }
        $('.wikitabs')
          .find('button')
          .removeClass('active');
        $('.wikitabs')
          .find(
            `button[data-tab="${$('.wikitabs option:selected').data('tab')}"]`,
          )
          .addClass('active');
      }
    });

    $('.newsletter-box').on('click', function() {
      $(window).scrollTop('0');
      $('.connector-newsletter')
        .find('.active')
        .removeClass('active');
      $(this).addClass('active');
      $('.post-head .cell').hide();
      $('.post-head')
        .find("[data-type='image']")
        .html(
          $(this)
            .find("[data-type='image']")
            .html(),
        );
      $('.post-head')
        .find("[data-type='title']")
        .html(
          $(this)
            .find("[data-type='title']")
            .html(),
        );
      $('.post-head')
        .find("[data-type='content']")
        .html(
          $(this)
            .find("[data-type='content']")
            .html(),
        );
      $('.post-head')
        .find("[data-type='button']")
        .html(
          $(this)
            .find("[data-type='button']")
            .html(),
        );
      $('.post-head')
        .find("[data-type='date']")
        .html(
          $(this)
            .find("[data-type='date']")
            .html(),
        );
      $('.post-head .cell').fadeIn(400);
    });

    $('.tab-materials').on('click', '.arrow-next', () => {
      $('.list-materials').slick('slickNext');
    });
    $('.tab-materials').on('click', '.arrow-prev', () => {
      $('.list-materials').slick('slickPrev');
    });

    $('.product-image').on('click', '.arrow-prev', () => {
      $('.hat-colors').slick('slickPrev');
    });

    $('.product-image').on('click', '.arrow-next', () => {
      $('.hat-colors').slick('slickNext');
    });

    $('.tab-forms').on('click', '.arrow-next', () => {
      $('.list-forms').slick('slickNext');
    });
    $('.tab-forms').on('click', '.arrow-prev', () => {
      $('.list-forms').slick('slickPrev');
    });

    $('.hat-colors, .hat-color').on(
      'beforeChange',
      (event, slick, currentSlide, nextSlide) => {
        if (
          $(`.hat-color .slick-slide[data-slick-index="${nextSlide}"]`)
            .find('img')
            .attr('src') === ''
        ) {
          // If statement to NOT load everytime N times the same picture if its already have been loaded
          $(`.hat-color .slick-slide[data-slick-index="${nextSlide}"]`)
            .find('img')
            .attr(
              'src',
              $(`.hat-color .slick-slide[data-slick-index="${nextSlide}"]`)
                .find('img')
                .data('original'),
            );
        }
      },
    );

    $('.connector-newsletter').on('click', '.arrow-next', function() {
      if (
        $(this)
          .parent()
          .children('.cell:visible').length > 1
      ) {
        $(this)
          .parent()
          .children('.cell:visible')
          .last()
          .next('.cell')
          .removeClass('hide-for-large');
        $(this)
          .parent()
          .children('.cell:visible')
          .first()
          .addClass('hide-for-large');
      }
    });

    $('.connector-newsletter').on('click', '.arrow-prev', function() {
      if (
        $(this)
          .parent()
          .children('.cell')
          .first()
          .is(':hidden')
      ) {
        if (
          $(this)
            .parent()
            .children('.cell:visible').length > 2
        ) {
          $(this)
            .parent()
            .children('.cell:visible')
            .last()
            .addClass('hide-for-large');
          $(this)
            .parent()
            .children('.cell:visible')
            .first()
            .prev('.cell')
            .removeClass('hide-for-large');
        } else {
          $(this)
            .parent()
            .children('.cell:visible')
            .first()
            .prev('.cell')
            .removeClass('hide-for-large');
        }
      }
    });

    $('.wikitabs button').on('click', function() {
      $('.wikitabs button').removeClass('active');
      $(this).addClass('active');
    });

    $(document).ready(function() {
      if ($('.banner-slider').children().length >= 2) {
        $('.banner-slider').slick({
          adaptiveHeight: false,
          dots: true,
          infinite: true,
          arrows: false,
          speed: 500,
          fade: true,
          cssEase: 'linear',
          appendDots: '.banner-dots-bar',
        });
      }
    });

    $('._brlbs-thumbnail').attr(
      'src',
      '/wp-content/themes/stetson-europe-chisel/dist/assets/images/karte_blur.jpg',
    );
  });

  // To have nice padding for the sliders
  $(window).resize(() => {
    if ($(window).width() < 480) {
      $('.slider-box-padding').css('height', $('.bx-viewport').height());
    }
  });

  // To have the filtrations (jobs page)
  $('.jobs-filter').on('click', '.jobs-btn', function() {
    const that = this;
    $(that)
      .siblings()
      .removeClass('active');
    $(that).toggleClass('active');
    /* eslint-disable */
    const active_array = [];

    // Prepare array of active buttons
    $('.jobs-filter .jobs-btn.active').each(function() {
      active_array.push($(this).data('job'));
    });

    $('.job-position').hide();
    $('.job-position').each(function() {
      const array_jobs = $(this)
        .data('filter')
        .split(',');
      if (array_jobs.contains(active_array)) {
        $(this).show();
      }
    });
  });

  /* eslint-enable */

  if ($('.store-container__filter').length) {
    var choosed_country = '--';
    var choosed_city = '--';
    var debug = false;

    $('.store-container__filter-countryfilter .select').on(
      'change',
      function() {
        choosed_country = $(this).val();

        if (choosed_country == '--') {
          if (debug) console.log('country: choosed_country == "--"');
          // das land ist uneingeschränkt
          // ziel:
          //  - stadtfilter wird auf -- gesetzt, alle städte sind verfügbar
          //  - alle länder sind verfügbar
          manipulate_city_selectbox_showall();
          output_show_all_countries();
          output_show_all_cities();
          set_filter_country_all();
          set_filter_cities_selected();
          output_hide_country_list_without_visibles();
        } else if (choosed_country != '--') {
          if (debug) console.log('country: choosed_country != "--"');
          // eine land wurde gefiltert
          // ziel:
          //  - alle städte aus diesem land sind verfügbar
          //  - alle länder sind verfügbar
          output_show_all_countries();
          output_show_all_cities();
          manipulate_city_selectbox('data-item', choosed_country);
          set_filter_cities_selected('data-item', '--');
          output_show_manipulated_store_list(choosed_country, '--');
        }
      },
    );

    $('.store-container__filter-citiesfilter .select').on('change', function() {
      choosed_city = $(this).val();

      if (choosed_city != '--' && choosed_country == '--') {
        if (debug)
          console.log('city: choosed_city != "--" && choosed_country == "--"');
        // eine stadt wurde gefiltert, während das land uneingeschränkt ist
        // ziel:
        //  - stadtfilter ist gefiltert, alle städte sind verfügbar
        //  - landfilter wird auf -- gesetzt, alle länder sind verfügbar
        //  - nur die stores in gewählter stadt werden in ausgabeliste gezeigt
        output_show_manipulated_store_list('--', choosed_city);
        output_hide_country_list_without_visibles();
      } else if (choosed_city == '--' && choosed_country != '--') {
        if (debug)
          console.log('city: choosed_city == "--" && choosed_country != "--"');
        // der städtefilter ist uneingeschränkt, während das land völlig egal ist
        // ziel:
        //  - stadtfilter wird auf -- gesetzt, alle städte sind verfügbar
        //  - landfilter wird auf -- gesetzt, alle länder sind verfügbar
        //  - alle stores werden in ausgabeliste gezeigt
        manipulate_city_selectbox('data-item', choosed_country);
        set_filter_cities_selected('value', choosed_city);
        output_show_manipulated_store_list(choosed_country, '--');
        //output_hide_country_list_without_visibles();
      } else if (choosed_city == '--' && choosed_country == '--') {
        if (debug)
          console.log('city: choosed_city == "--" && choosed_country == "--"');
        // der städtefilter ist uneingeschränkt, während das land völlig egal ist
        // ziel:
        //  - stadtfilter wird auf -- gesetzt, alle städte sind verfügbar
        //  - landfilter wird auf -- gesetzt, alle länder sind verfügbar
        //  - alle stores werden in ausgabeliste gezeigt
        output_show_all_countries();
        output_show_all_cities();
      } else if (choosed_city != '--' && choosed_country != '--') {
        if (debug)
          console.log('city: choosed_city != "--" && choosed_country != "--"');
        // eine stadt wurde gewählt, während bereits das land gewählt war
        // ziel:
        //  - stadtfilter ist gefiltert, alle städte aus dem vorab gewählten land sind verfügbar
        //  - landfilter bleibt unverändert, alle länder sind verfügbar
        //  - nur die stores in gewählter stadt werden in ausgabeliste gezeigt
        output_show_manipulated_store_list(choosed_country, choosed_city);
        manipulate_city_selectbox('data-item', choosed_country);
        set_filter_cities_selected('value', choosed_city);
        output_hide_country_list_without_visibles();
      }
    });

    // FERTIG
    function manipulate_city_selectbox(key = 'data-item', value = '--') {
      // zeige nur ausgewählte
      if (debug) console.log(' --> manipulate_city_selectbox()', key, value);
      $('.store-container__filter-citiesfilter select option').hide();
      $(
        '.store-container__filter-citiesfilter select option[' +
          key +
          '="' +
          value +
          '"]',
      ).show();
      $(
        '.store-container__filter-citiesfilter select option[data-item="--"]',
      ).show();
    }

    function manipulate_city_selectbox_showall() {
      // zeige alle
      if (debug) console.log(' --> manipulate_city_selectbox_showall()');
      $('.store-container__filter-citiesfilter select option').show();
    }

    function output_hide_country_list_without_visibles() {
      // räume den output auf, laender ohne städte werden nicht angezeigt
      var has_visible_items = true;
      if (debug)
        console.log(' --> output_hide_country_list_without_visibles()');
      $('.store-container__countrylist-stores-wrapper')
        .parent()
        .show();
      $('.store-container__countrylist-stores-wrapper').each(function() {
        if (
          $(this).find('.store-container__countrylist-stores:visible').length <
          1
        ) {
          has_visible_items = false;
          $(this)
            .parent()
            .hide();
        }
      });
    }

    function output_show_all_countries() {
      if (debug) console.log(' --> output_show_all_countries()');
      $('.store-container__countrylist').show();
      $('.store-container__filter-citiesfilter select option').show();
    }

    function set_filter_country_all() {
      if (debug) console.log(' --> set_filter_country_all()');
      $(
        '.store-container__filter-countryfilter select option[data-item="--"]',
      ).prop('selected', true);
    }

    function output_show_all_cities() {
      if (debug) console.log(' --> output_show_all_cities()');
      $('.store-container__countrylist-stores').show();
      $('.store-container__countrylist-stores-wrapper')
        .parent()
        .show();
    }

    function set_filter_cities_selected(key = 'data-item', value = '--') {
      if (debug) console.log(' --> set_filter_cities_selected()', key, value);
      $(
        '.store-container__filter-citiesfilter select option[' +
          key +
          ' = "' +
          value +
          '"]',
      ).prop('selected', true);
    }

    function output_show_manipulated_store_list(country = '--', city = '--') {
      if (debug)
        console.log(' --> output_show_manipulated_store_list()', country, city);

      if (city == '--' && country == '--') {
        if (debug) console.log(' -- --> city == "--" && country == "--"');
        $('.store-container__countrylist-stores').show();
        $('.store-container__countrylist').show();
      } else if (city != '--' && country == '--') {
        if (debug) console.log(' -- --> city != "--" && country == "--"');
        $('.store-container__countrylist').show();
        $('.store-container__countrylist-stores').hide();
        $(
          '.store-container__countrylist-stores[data-item="' + city + '"]',
        ).show();
      } else if (city == '--' && country != '--') {
        if (debug) console.log(' -- --> city == "--" && country != "--"');
        $('.store-container__countrylist-stores').show();
        $('.store-container__countrylist').hide();
        $('.store-container__countrylist[data-item="' + country + '"]').show();
      } else if (city != '--' && country != '--') {
        if (debug) console.log(' -- --> city != "--" && country != "--"');
        $('.store-container__countrylist-stores').hide();
        $('.store-container__countrylist').show();
        $(
          '.store-container__countrylist-stores[data-item="' + city + '"]',
        ).show();
      }
    }
  }

  // Mobile filtration (expand) logic
  $('.jobs-expand').on('click', function() {
    $(this).toggleClass('active');
    $(this)
      .prev('.jobs-row')
      .toggleClass('active');

    if (
      $(this)
        .prev('.jobs-row')
        .hasClass('active')
    ) {
      // Filters opening
      $(this)
        .prev('.jobs-row')
        .find('.jobs-btn')
        .show();
      $(this)
        .prev('.jobs-row')
        .height(
          $(this)
            .prev('.jobs-row')
            .find('.jobs-btns')
            .height(),
        );
    } else {
      // Filters closing
      $(this)
        .prev('.jobs-row')
        .height('');

      if (
        $(this)
          .prev('.jobs-row')
          .find('.jobs-btn.active').length
      ) {
        // User has an active filter

        $(this)
          .prev('.jobs-row')
          .find('.jobs-btn')
          .not('.active')
          .hide();
      } else {
        $(this)
          .prev('.jobs-row')
          .find('.jobs-btn')
          .not(':first')
          .fadeOut(200);
      }
    }
  });
};

export default stetson;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/stetson-europe-chisel/src/scripts/additional/stetson.js